import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import dayjs from 'dayjs';
import { setDefaultLocale } from 'react-datepicker';
import classNames from 'classnames';
import { displayLang, LANGUAGES } from '@/config';
import { toDayjsLocale } from '@/utils/dayjsLocale';
import IcChevronDown from '@/assets/icons/ChevronDown.svg?react';
import IcChevronUp from '@/assets/icons/ChevronUp.svg?react';
import styles from './Languages.module.scss';

interface LanguagesProps {
  popoverId?: string;
}

const Languages = ({ popoverId = 'language-list' }: LanguagesProps) => {
  const { i18n, t } = useTranslation(['common']);

  useEffect(() => {
    const dayjsLocale = toDayjsLocale(i18n.language);
    dayjs.locale(dayjsLocale);
    setDefaultLocale(dayjsLocale);
  }, [i18n.language]);

  const handleChangeLanguage = (langKey: string) => () => {
    void i18n.changeLanguage(langKey);
    const dayjsLocale = toDayjsLocale(langKey);
    dayjs.locale(dayjsLocale);
    setDefaultLocale(dayjsLocale);
  };

  return (
    <div className={styles.wrapper}>
      <button
        type="button"
        aria-label={t('common:header.languages')}
        className={styles.selected}
        popoverTarget={popoverId}
      >
        {displayLang(i18n.language) ?? 'en'}
        <IcChevronDown className={classNames(styles.icon, styles.down)} />
        <IcChevronUp className={classNames(styles.icon, styles.up)} />
      </button>
      <div className={styles.menu} popover="auto" id={popoverId}>
        {Object.entries(LANGUAGES).map(([langKey, language]) => {
          return (
            <button
              type="button"
              key={language.name}
              className={classNames(styles.button, {
                [styles.active]: langKey === i18n.language,
              })}
              onClick={handleChangeLanguage(langKey)}
              popoverTargetAction="hide"
              popoverTarget={popoverId}
            >
              {displayLang(language.short)}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Languages;
